<template>
  <div class="tables-wrapper">
    <div class="home-header">Доступы</div>
    <div class="products-wrapper">
      <a-table
               :columns="getExtendedColumns('tests', 'Оценка ЭИ')"
               rowKey="id" :data-source="tableData.tests?.children"
               :scroll="{ x: 900 }"
               :components="getTableComponents('tests')"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
      />

      <a-table
               :columns="getExtendedColumns('courses', 'Развитие')"
               rowKey="id" :data-source="tableData.courses?.children"
               :scroll="{ x: 900 }"
               :components="getTableComponents('courses')"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
      />

      <a-table v-if="tableData?.tools"
               :columns="getShortListColumns('tools', 'Ежедневные помощники')"
               rowKey="id" :data-source="tableData.tools"
               :scroll="{ x: 900 }"
               :components="getTableComponents('tools')"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
      />

      <a-table v-if="tableData.analytics?.children"
               :columns="getShortListColumns('analytics', 'Аналитика')"
               rowKey="id" :data-source="tableData.analytics?.children"
               :scroll="{ x: 900 }"
               :components="getTableComponents('analytics')"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
      />

      <a-table v-if="tableData?.subscriptions"
               :columns="getShortListColumns('subscriptions', 'Подписки')"
               rowKey="id" :data-source="tableData.subscriptions"
               :scroll="{ x: 900 }"
               :components="getTableComponents('subscriptions')"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
      />

      <div class="add-product-button">
        <a-button type="default" class="secondary-button" @click="showOrderModal">
          Заказать продукт
        </a-button>

        <a-button type="default" class="secondary-button" @click="showManageAccessModal">
          Управление доступами
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, ref} from "@vue/runtime-core";
import useCheckRights from "../../mixins/useCheckRights";
import {useStore} from "vuex";
import PopUpForm from "@/components/Popups/PopUpForm";
import {PlusCircleOutlined, MinusCircleOutlined, MinusOutlined} from '@ant-design/icons-vue'
import { h } from 'vue'
import { PlusOutlined, ClockCircleOutlined } from '@ant-design/icons-vue';
import StatusByPassing from "@/components/Cards/StatusByPassing.vue";
import NotFoundIcon from '@/assets/images/icons/no_data.svg';
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";

export default {
  components: {
    ManageAccessForm,
    StatusByPassing,
    PopUpForm,
    PlusCircleOutlined,
    MinusCircleOutlined,
    ClockCircleOutlined,
    PlusOutlined
  },
  name: "DashboardProductTables",
  props: {
    tableData: Object
  },
  emits: ['showOrderForm', 'showManageAccessForm'],
  setup(props, context) {
    const store = useStore(),
        {getRight} = useCheckRights();

    const profile = computed(() => store.state.profile.profile),
        companyActivityData = computed(() => store.state.companyActivity);

    const collapsedMap = ref({
      tests: true,
      course: false,
      analytics: false,
      tools: false,
      subscriptions: false,
    });

    const getTableComponents = (tableKey) => ({
      body: {
        wrapper: (props, { slots }) =>
            h(
                'tbody',
                {
                  ...props,
                  style: {
                    ...(props.style || {}),
                    display: collapsedMap.value[tableKey] ? '' : 'none',
                  },
                },
                slots.default?.()
            ),
      },
    })

    const columnsSubscription = [
      {
        title: 'Действует до',
        dataIndex: 'expires_at',
        key: 'expires_at',
        width: 15,
        align: 'center',
      },
    ];

    const emptySlot = () =>
        h('div', { class: 'no-data-wrapper' }, [
          h('img', { src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);


    const renderClockIcon = ({ record }) => {
        const children = [h('span', record.validUntil)];

        if (record.timeRemaining && record.timeRemaining < 30) {
          children.push(
              h(ClockCircleOutlined, {
                class: 'circle-clock',
                style: {
                  color: '#FAAD14',
                },
              }),
          );
        }

        return h(
            'div',
            {
              style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                columnGap: '2px',
                flexDirection: 'row-reverse',
                lineHeight: '1.2',
              },
            },
            children
        );
    }

    const renderCollapseElement = (key) =>
        h(
            "span",
            {
              class: [
                "custom-collapse-expand-icon",
                collapsedMap.value[key] ? "custom-collapse-expand-icon--active" : "",
              ],
              onClick: (e) => {
                e.stopPropagation();
                collapsedMap.value[key] = !collapsedMap.value[key];
              },
            },
            [
              h(collapsedMap.value[key] ? MinusOutlined : PlusOutlined, {
                key: collapsedMap.value[key] ? "minus" : "plus",
              }),
            ]
        );

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: () => renderCollapseElement(key),
          dataIndex: 'toggle',
          key: 'toggle',
          width: 22,
          align: 'center',
        },
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 550,
          align: 'left',
        },
        {
          title: 'Доступ',
          dataIndex: 'has_access',
          key: 'has_access',
          width: 70,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 100,
          align: 'center',
          customRender: renderClockIcon,
        },
      ];
    }

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: () => renderCollapseElement(key),
          dataIndex: 'toggle',
          key: 'toggle',
          width: 8,
          align: 'center',
        },
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 120,
          align: 'left',
        },
        {
          title: 'Куплено',
          dataIndex: 'purchased',
          key: 'purchased',
          width: 25,
          align: 'right',
        },
        {
          title: 'Выдано',
          dataIndex: 'issued',
          key: 'issued',
          width: 25,
          align: 'right',
        },
        {
          title: 'Осталось',
          dataIndex: 'remaining',
          key: 'remaining',
          width: 25,
          align: 'right',
        },
        {
          title: 'Завершено',
          dataIndex: 'completed',
          key: 'completed',
          width: 25,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 35,
          align: 'center',
          customRender: renderClockIcon,
        },
      ]
    }

    const showOrderModal = () => {
      context.emit('showOrderForm')
    }

    const showManageAccessModal = () => {
      context.emit('showManageAccessForm')
    }

    return {
      getRight,
      profile,
      showOrderModal,
      companyActivityData,
      emptySlot,
      columnsSubscription,
      getTableComponents,
      getExtendedColumns,
      getShortListColumns,
      showManageAccessModal
    };
  },
};
</script>

<style scoped lang="scss">
.collapse-table-header {
  display: flex;
  justify-content: space-between;
}

:deep(.custom-collapse-expand-icon) {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fff;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, transform 0.2s;
  color: var(--main-font);
}

:deep(.custom-collapse-expand-icon--active) {
  transform: translateY(1px);
}

.collapse-header {
  font-size: 14px;
  font-weight: 500;
  text-align: start;
  width: 580px;
}

.collapse-columns {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--neutral-text-description);
}

.collapse-columns > .collapse-column {
  width: 70px;
}

.collapse-columns > .collapse-column:last-child {
  width: 85px;
}

:deep(.ant-collapse-header) {
  padding: 5px 15px !important;
}

.ant-collapse {
  border: none !important;
}

.ant-collapse-item {
  border-bottom: none !important;
}

.ant-collapse-header {
  border-bottom: none !important;
}

.ant-collapse-content {
  border-top: none !important;
  border-bottom: none !important;
}

.ant-collapse-content-box {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border: none !important;
}

:deep(.ant-collapse-content-box) {
  padding: 0 !important;
}

.products-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

.add-product-button {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  column-gap: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 5px;
  }
}

.ant-table-thead > tr > th {
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  background-color: #fafafa;
}

.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 8px;
  font-size: 14px;
}

.ant-table-tbody > tr > td:first-child {
  text-align: left;
}

:deep(.ant-table-thead>tr>th) {
  padding: 5px !important;
  color:  var(--neutral-text-description);
}

:deep(.ant-table-thead>tr>th:not(:first-child)) {
  padding: 5px !important;
  color:  var(--neutral-text-description);
  font-weight: 400;
}

:deep(.ant-table-thead>tr>th:nth-child(2)) {
  color: var(--dp-text-color);
}

:deep(.ant-table-tbody>tr>td) {
  padding: 8px !important;
}

:deep(.ant-table-tbody>.ant-table-measure-row>td) {
  padding: 0 !important;
}

.home-header {
  margin-bottom: 20px;
  font-size: 20px;
  text-align: left;
  font-weight: 500;
}

.tables-wrapper {
  width: 100%;
}
</style>